import Question from 'components/custom/Question';
import Choice from 'components/custom/Choice';
import Explanation from 'components/custom/Explanation';
import * as React from 'react';
export default {
  Question,
  Choice,
  Explanation,
  React
};